import { z } from 'zod';
const VALID_TAG_REGEX = /^[a-zA-Z][\w-]{0,63}$/;
/**
 * A single tag label, as accepted on the way in. Must start with a letter and may only
 * contain word characters and hyphens thereafter. Applies to both a tag's name and its
 * category. Distinct from {@link FlowTagSchema}, which describes tags on the way out and
 * stays permissive because stored tags predate this validation.
 */
export const FlowTagNameSchema = z.string().trim().min(1).max(64).regex(VALID_TAG_REGEX);
export const FlowTagNameCollectionSchema = z
    .array(FlowTagNameSchema)
    .refine((tags) => new Set(tags).size === tags.length);
export const FlowTagInputsSchema = z.array(z.object({
    name: FlowTagNameSchema,
    category: FlowTagNameSchema.nullish(),
}));
export var FlowTagCategory;
(function (FlowTagCategory) {
    FlowTagCategory["Custom"] = "Custom";
    FlowTagCategory["FlowType"] = "FlowType";
    FlowTagCategory["SolutionArea"] = "SolutionArea";
    FlowTagCategory["SupportedEhr"] = "SupportedEhr";
    FlowTagCategory["UseCase"] = "UseCase";
})(FlowTagCategory || (FlowTagCategory = {}));
/** Whether a caller may introduce tags that do not exist yet, or may only attach known ones. */
export var FlowTagCreationMode;
(function (FlowTagCreationMode) {
    FlowTagCreationMode["CreateNewTags"] = "CreateNewTags";
    FlowTagCreationMode["IgnoreNewTags"] = "IgnoreNewTags";
})(FlowTagCreationMode || (FlowTagCreationMode = {}));
/** Whether both halves of a tag satisfy {@link FlowTagNameSchema}; a null category is allowed. */
export function isValidFlowTag(props) {
    const { name, category } = props;
    const isNameValid = FlowTagNameSchema.safeParse(name).success;
    const isCategoryValid = category === null || FlowTagNameSchema.safeParse(category).success;
    return isNameValid && isCategoryValid;
}
/**
 * Whether two tags are the same for deduplication: names compare case-insensitively, and a null
 * category is the same as an empty one.
 */
export function isFlowTagEqual(first, second) {
    return (first.name.toLowerCase() === second.name.toLowerCase() &&
        (first.category?.toLowerCase() ?? '') === (second.category?.toLowerCase() ?? ''));
}
//# sourceMappingURL=tags.js.map